import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=23328a56&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=23328a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23328a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23328a56')) {
      api.createRecord('23328a56', component.options)
    } else {
      api.reload('23328a56', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=23328a56&scoped=true&", function () {
      api.rerender('23328a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fGZPWHHt7bT9/JS/comp/PopupDialog.vue"
export default component.exports